// src/app/shared/utils/adobe-ecid.ts
import { BehaviorSubject, from, Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

const ecidSubject = new BehaviorSubject<string | null>(null);

export function setAdobeECID(ecid: string) {
  ecidSubject.next(ecid);
}

export function getAdobeECID$(): Observable<string | null> {
  return ecidSubject.asObservable();
}

export function getAdobeECID(): Observable<string> {
  const alloy = (window as any).alloy;
  if (typeof alloy === 'function') {
    return from(alloy('getIdentity')).pipe(
      switchMap((result: any) => {
        const ecid = result?.identity?.ECID || '';
        setAdobeECID(ecid); // update subject when ECID is fetched
        return of(ecid);
      }),
      catchError(() => of(''))
    );
  }
  return of('');
}
